const weekDays = ['Alle Tag', 'Keine Tage', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So']

export default (num = 0, weekDaysArr = weekDays) => {
	let res = []
	const allDays = weekDays.slice(2), // Excluding 'all' and 'none' values
		possibleOptions = allDays.map((option, i) => Math.pow(2, i))

	if(possibleOptions.indexOf(num) >= 0) {
		res.push(allDays[possibleOptions.indexOf(num)])
	} else if(num === 127) {
		res.push(weekDays[0])
	} else if(num === 0) {
		res.push(weekDays[1])
	} else {
		possibleOptions.reduceRight((sum, val, ind, arr) => {
			let newSum = sum
			if(num >= newSum + val) {
				newSum += val
				res.push(allDays[ind])
				if(ind === 0 && newSum !== num) {
					res = [] // Incorrect 'num'
					// console.log('Received incorrect number of week days.')
				}
			}
			return newSum
		}, 0)
	}
	return res.join(', ')
}
